import { render, staticRenderFns } from "./WatchTogetherSlider.vue?vue&type=template&id=44bcccf0&scoped=true&"
import script from "./WatchTogetherSlider.vue?vue&type=script&lang=js&"
export * from "./WatchTogetherSlider.vue?vue&type=script&lang=js&"
import style0 from "./WatchTogetherSlider.vue?vue&type=style&index=0&id=44bcccf0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44bcccf0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src3547940844/src/v-meetings/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('44bcccf0')) {
      api.createRecord('44bcccf0', component.options)
    } else {
      api.reload('44bcccf0', component.options)
    }
    module.hot.accept("./WatchTogetherSlider.vue?vue&type=template&id=44bcccf0&scoped=true&", function () {
      api.rerender('44bcccf0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/watchTogether/ongoing/WatchTogetherSlider.vue"
export default component.exports